var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEconomyMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109,62v5.39m0-29.58v5.61m5.37,2.11s-9.85-4.12-10.8,1.9c-1.21,7.65,10.59,3.06,11,9.72s-8.89,5.06-11.32,2.53m42,15.22A16,16,0,0,1,147,82c0,13.24-17.07,24-38.11,24S70.77,95.24,70.77,82a15.92,15.92,0,0,1,1.72-7.14m72.78-14.52A16,16,0,0,1,147,67.47c0,13.24-17.07,24-38.11,24s-38.11-10.73-38.11-24a15.92,15.92,0,0,1,1.72-7.14M147,52.94c0,13.24-17.07,24-38.11,24s-38.11-10.73-38.11-24,17.06-24,38.11-24S147,39.7,147,52.94Zm-6.91,85.85,15.15-16.37V101s1.11-5.5,6.07-5.23,6.35,3.58,6.35,5.5v29.18L146.4,154.9l-.27,27.52H121V148.29s-1.57-5.12,6.9-14.31c7.14-7.74,20.35-25.95,27.25-17.42M77.94,138.79,62.79,122.42V101s-1.11-5.5-6.07-5.23-6.35,3.58-6.35,5.5v29.18L71.61,154.9l.28,27.52H97V148.29s1.58-5.12-6.89-14.31C83,126.24,69.74,108,62.85,116.56"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEconomyMoney);
export default __webpack_public_path__ + "static/media/ECONOMY_MONEY.732b0353bc71f9678ac033312a3d8d86.svg";
export { ForwardRef as ReactComponent };